import '@f-fertighaus/layout/PageHeader/SSR/PageHeaderSSR'
import '@f/components/PageSharing'
import '@js/common/site-wide'
import '@f/elements/AnchorsNavigation'
import '@f/widgets/CardCarousel/CardCarouselHTML'
import '@f/wagtail-blocks/Carousel'
import '@f/wagtail-blocks/HouseMosaic'
import '@f-fertighaus/components/YoutubeVideo/YoutubeVideoHTML'
import '@f-fertighaus/widgets/FloatingBanner'

import React from 'react'
import { createRoot } from 'react-dom/client'

import FullscreenGallery from '@js/ancient-code/FullscreenGallery'
import { patch, post } from '@js/common/api'
import { getUrl } from '@js/common/getUrlByDomain'
import { getUUIDv4 } from '@js/common/utils'

import Modal from '@f/components/Modal'

import FinanceEntry, {
  FinanceEntryPanel
} from '@f-fertighaus/applications/FinanceEntry'
import RequestWizard from '@f-fertighaus/applications/RequestWizard'

/* Dynamic scrollable tables */
void (function () {
  let tables = [...document.querySelectorAll('.table table')]

  tables.map(table => {
    let checkTable = () => {
      if (table.scrollWidth > table.offsetWidth) {
        table.parentNode.parentNode.classList.add('has-scroll')
      } else {
        table.parentNode.parentNode.classList.remove('has-scroll')
      }
    }

    checkTable()

    window.addEventListener('resize', () => {
      checkTable()
    })
  })
})()

/* Check if any link contain the budget-calc trigger */
void (function () {
  let container = document.querySelector('main')
  container.addEventListener('click', async function (event) {
    const target = event.target

    if (target.href && /#budgethilfe/.test(target.href)) {
      event.preventDefault()

      const modal = new Modal()

      const openFlow = async flowType => {
        let nextModal = new Modal()

        if (flowType === 'budget_calculator') {
          const { default: BudgetCalculatorModal } = await import(
            '@f-fertighaus/applications/BudgetCalculatorModal'
          )
          nextModal.openModal({
            component: (
              <BudgetCalculatorModal
                {...window.SherlockContainer.BudgetCalculator}
              />
            )
          })
        } else if (flowType === 'finance') {
          nextModal.openModal({
            component: (
              <RequestWizard requestType='finance' financeFunnel='finance' />
            )
          })
        }
      }

      modal.openModal({
        component: <FinanceEntryPanel openFlow={openFlow} />,
        options: {
          className: 'ModalFinance'
        }
      })
    }

    if (target.href && /#budget-calc/.test(target.href)) {
      event.preventDefault()
      const { default: BudgetCalculatorModal } = await import(
        '@f-fertighaus/applications/BudgetCalculatorModal'
      )

      const modal = new Modal()

      modal.openModal({
        component: (
          <BudgetCalculatorModal
            {...window.SherlockContainer.BudgetCalculator}
          />
        )
      })
    }

    if (target.href && /#finance/.test(target.href)) {
      event.preventDefault()

      window.location.href = getUrl('financeAssistance')()
    }
  })
})()

// Render Finance Funnel Entry - Mobile/Tablet
let financeFunnelAnchors = document.querySelectorAll('.js-finance-entry')

for (const anchor of financeFunnelAnchors) {
  const root = createRoot(anchor)
  root.render(<FinanceEntry />)
}

/* Star Rating */
void (function () {
  // TODO: Deprecated - NR-5392
  // Star rating unfilled event listeners
  let starRatingUnfilled = document.querySelectorAll('.js-star-rating-unfilled')
  for (const star of starRatingUnfilled) {
    star.addEventListener('click', function () {
      if (
        document.querySelector('.js-ArticleRatingTitle').innerText ==
        'Vielen Dank!'
      ) {
        return
      }
      let starRatingUnfilled = document.querySelectorAll(
        '.js-star-rating-unfilled'
      )
      let starRatingFilled = document.querySelectorAll('.js-star-rating-filled')
      let rating = parseInt(star.dataset['rating'])
      for (let i = 0; i < rating; i++) {
        starRatingFilled[i].style.display = 'block'
        starRatingUnfilled[i].style.display = 'none'
      }
      post(`/rating/${star.dataset['page']}/`, {
        rating: star.dataset['rating']
      }).then(data => {
        let rating = data['rating']['rating__avg'] + ''
        document.querySelector('.js-rating-text').style.display = 'block'
        document.querySelector('.js-placeholder-text').style.display = 'none'
        document.querySelector('#ratingValue').innerText = rating
          .replace('.', ',')
          .substring(0, 4)
        document.querySelector('#totalRatings').innerText = data['total']
        window.localStorage.setItem('ratingUUID', data['uuid'])
        document.querySelector('.js-ArticleRatingTitle').innerText =
          'Vielen Dank!'
        document.querySelector('.js-ratingstep2').style.display = 'block'
      })
    })
  }

  // Send feedback button
  const sendFeedback = document.querySelector('.js-send-feedback')
  if (sendFeedback) {
    sendFeedback.addEventListener('click', function () {
      let page = document.querySelector('.js-ratingstep2').dataset['page']
      document.querySelector('.js-ratingstep2').style.display = 'none'
      document.querySelector('.js-ratingstep3').style.display = 'block'
      patch(`/rating/${page}/`, {
        comment: document.querySelector('[name=star-rating-message]').value,
        uuid: window.localStorage.getItem('ratingUUID')
      })
    })
  }
})()

/* Fullscreen Gallery */
void (function () {
  let cdnImages = document.querySelectorAll('[data-zoom-src]')
  for (const image of cdnImages) {
    image.addEventListener('click', () => {
      const modal = new Modal()
      modal.openModal({
        component: <FullscreenGallery slides={[image.dataset.zoomSrc]} />
      })
    })
  }
})()

/* Sidebar Quiz Widget */
void (function () {
  const quizWidgetElement = document.querySelector('.js-quiz-widget')
  if (!quizWidgetElement) return

  const flow_id = getUUIDv4()

  /* Attach flow id to all question options */
  const questionLinks = document.querySelectorAll('.js-quiz-option')
  for (const link of questionLinks) {
    link.href =
      link.href + ((link.href.indexOf('#') > 0 ? '&fi=' : '#fi=') + flow_id)

    link.addEventListener('click', function (event) {
      const target = event.currentTarget

      if (
        target.href &&
        !(event.ctrlKey || event.metaKey || event.shiftKey) &&
        target.target !== '_blank'
      ) {
        window.location = target.href
      }

      if (
        target.href &&
        (event.ctrlKey ||
          event.metaKey ||
          event.shiftKey ||
          target.target === '_blank')
      ) {
        return
      }

      event.preventDefault()
    })
  }
})()
